<script>
    import { createEventDispatcher } from 'svelte'
    import * as api from '../../../../shared/api.js'
    
    const dispatch = createEventDispatcher()

    export let domain
    export let data
    export let sheet

    $: disabled = !data.credential
    $: valid    = sheet.id !== '' && sheet.range !== ''
    let loading = false

    function loadSheet() {
        loading = true
        api
            .post('/integrations/google/sheets/load-range', {
                domain: domain.id,
                credential: data.credential.id,
                sheet
            })
            .then(api.toJsonIf200)
            .then(json => {
                loading = false
                dispatch('done', json)
            })
            .catch(console.log)
    }
</script>

<div class="ui basic segment" class:loading>
    <form class="ui big form">
        <div class="field" class:disabled>
            <label>Arquivo</label>
            <input  bind:value={sheet.id}
                    type="text"
                    autocomplete="false">
        </div>
        <div class="field" class:disabled>
            <label>Intervalo</label>
            <input  bind:value={sheet.range}
                    type="text"
                    autocomplete="false">
        </div>
        <div class="field" class:disabled={disabled || !valid}>
            <div class="ui blue button" on:click={loadSheet}>Pesquisar</div>            
        </div>
    </form>
</div>
